export default "__VITE_ASSET__xK$BIdJ6__"